/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChartBubbleFilled = createReactComponent(
  "chart-bubble-filled",
  "IconChartBubbleFilled",
  [
    [
      "path",
      {
        d: "M6 12a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z",
        fill: "currentColor",
        key: "svg-0",
        strokeWidth: "0"
      }
    ],
    [
      "path",
      {
        d: "M16 16a3 3 0 1 1 -2.995 3.176l-.005 -.176l.005 -.176a3 3 0 0 1 2.995 -2.824z",
        fill: "currentColor",
        key: "svg-1",
        strokeWidth: "0"
      }
    ],
    [
      "path",
      {
        d: "M14.5 2a5.5 5.5 0 1 1 -5.496 5.721l-.004 -.221l.004 -.221a5.5 5.5 0 0 1 5.496 -5.279z",
        fill: "currentColor",
        key: "svg-2",
        strokeWidth: "0"
      }
    ]
  ]
);

export { IconChartBubbleFilled as default };
//# sourceMappingURL=IconChartBubbleFilled.js.map
